module.exports = __webpack_public_path__ + "img/quotes.f67efd81.svg";